import { createApp } from 'vue';
import wealthD1PTable from '../../../wealth/D1PTable.vue'
const appElements = document.querySelectorAll('.vue-wealth-render-d1')

Array.from(appElements).forEach(element => {
    createApp(wealthD1PTable).mount(element);
});
